module.exports = __webpack_public_path__ + "static/media/komb-is-correct.75a0b3b5.mp3";